import { t } from 'i18next';

export const controlColumnsConfigs = [
  {
    id: 'COMMENTS',
    visible: true,
    label: t('exibirComentarios'),
  },
  {
    id: 'CLIENT_NAME',
    visible: true,
    label: t('cliente'),
  },
  {
    id: 'UNIT_NAME',
    visible: true,
    label: t('unidade'),
  },
  {
    id: 'MACHINE_NAME',
    visible: true,
    label: t('maquina'),
  },
  {
    id: 'ASSET_NAME',
    visible: true,
    label: t('ativo'),
  },
  {
    id: 'DEVICE_CODE',
    visible: true,
    label: t('dispositivo'),
  },
  {
    id: 'HEALTH_INDEX',
    visible: true,
    label: t('saudeAtual'),
  },
  {
    id: 'HEALTH_DESC',
    visible: true,
    label: t('falhas'),
  },
  {
    id: 'WORK_ORDER_HIST_FAULT_INDEX',
    visible: true,
    label: t('saudeReportadaNaOS'),
  },
  {
    id: 'WORK_ORDER_HIST_FAULT_NAME',
    visible: true,
    label: t('falhaReportadaNaOS'),
  },
  {
    id: 'DAT_REPORT',
    visible: true,
    label: t('ultimaDeteccao'),
  },
  {
    id: 'WORK_ORDER_HIST_STATE_ID',
    visible: true,
    label: t('statusDaOS'),
  },
  {
    id: 'WORK_ORDER_HIST_CREATED_WO',
    visible: true,
    label: t('aberturaDaOS'),
  },
  {
    id: 'WORK_ORDER_HIST_UPDATED_AT',
    visible: true,
    label: t('ultimaAtualizacaoDaOS'),
  },
  {
    id: 'WORK_ORDER_HIST_CLOSED_WO',
    visible: true,
    label: t('fechamentoDaOS'),
  },
  {
    id: 'WORK_ORDER_HIST_WO_CODE',
    visible: true,
    label: t('numeroDaOS'),
  },
  {
    id: 'ALERT_STATUS',
    visible: true,
    label: t('statusDoAlarme'),
  },
  {
    id: 'WORK_ORDER_MAINTENCE',
    visible: true,
    label: t('statusDaManutencao'),
  },
];
